export default __webpack_public_path__ + "static/img/vogue_scene_animated_0769.7e8aedf.webp";